import { render, staticRenderFns } from "./coachCardDetails.vue?vue&type=template&id=4bd018ad&"
import script from "./coachCardDetails.vue?vue&type=script&lang=js&"
export * from "./coachCardDetails.vue?vue&type=script&lang=js&"
import style0 from "./coachCardDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports